// src/components/MapWithDrawing/DrawingToolbar.js
import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import {
    AddLocation, Timeline, Layers, RadioButtonUnchecked, Brush, CheckBoxOutlineBlank
} from '@material-ui/icons';

const tools = [
    { type: 'marker', label: 'Marker', icon: <AddLocation /> },
    { type: 'polyline', label: 'Line', icon: <Timeline /> },
    { type: 'rectangle', label: 'Rectangle', icon: <CheckBoxOutlineBlank /> },
    { type: 'polygon', label: 'Polygon', icon: <Layers /> },
    { type: 'circle', label: 'Circle', icon: <RadioButtonUnchecked /> },
    { type: 'freedraw', label: 'Freehand', icon: <Brush /> },
];

// Memoize this component
const DrawingToolbar = React.memo(({ onToolActivate, isDrawingMode, buttonGroupStyle }) => {
    return (
        <>
            <Typography variant="subtitle1" gutterBottom>Add New Area</Typography>
            <Box className={buttonGroupStyle}>
                {tools.map(tool => (
                    <Button
                        key={tool.type}
                        size="small"
                        variant="outlined"
                        startIcon={tool.icon}
                        onClick={() => onToolActivate(tool.type)}
                        disabled={isDrawingMode}
                    >
                        {tool.label}
                    </Button>
                ))}
            </Box>
        </>
    );
});

export default DrawingToolbar;
